import React from 'react';
import RoleSpecificFields from './RoleSpecificFields.jsx';
import { FaUserPlus } from 'react-icons/fa';

function RegistrationForm({
    role,
    formData,
    isLoading,
    logoName,
    registrationName,
    nicFrontName,
    nicBackName,
    billFrontName,
    billBackName,
    nationalities,
    countries,
    genders,
    propertyTypes,
    districts,
    handleChange,
    handleFileChange,
    handleSubmit,
}) {
    // Collect all props needed by the RoleSpecificFields
    const fieldProps = {
        formData,
        logoName,
        registrationName,
        nicFrontName,
        nicBackName,
        billFrontName,
        billBackName,
        nationalities,
        countries,
        genders,
        propertyTypes,
        districts,
        handleChange,
        handleFileChange,
    };

    return (
        <form className="register-form-premium" onSubmit={handleSubmit}>
            <RoleSpecificFields role={role} {...fieldProps} />
            
            <div className="premium-footer-actions">
                <div className="terms-premium">
                    <input type="checkbox" id="terms-check" required />
                    <label htmlFor="terms-check">I agree to the <span>Terms & Privacy</span></label>
                </div>

                <button type="submit" className="btn-premium-action" disabled={isLoading}>
                    {isLoading ? "Processing..." : <><FaUserPlus /> Join Soloway</>}
                </button>
            </div>
        </form>
    );
}

export default RegistrationForm;